import PullHandle from '@components/shared/PullHandle/PullHandle'

type DockSettingsHandleProps = {
  onOpenSettings: () => void
}

/** Opens reading settings from the dock's upward pull handle. */
export default function DockSettingsHandle({ onOpenSettings }: DockSettingsHandleProps) {
  return (
    // Keep the original 4px indicator and 6px gap; the touch target must not enlarge the dock.
    <div className="relative h-1 w-16 mb-1.5">
      <PullHandle
        direction="up"
        onActivate={onOpenSettings}
        label="Okuma ayarlarını açmak için yukarı çek veya dokun"
        title="Okuma ayarları için yukarı çek"
        className="absolute -top-2.5 left-0"
      />
    </div>
  )
}
